import MarkerPin from "@/assets/icons/marker-pin.svg";
import { cn } from "@/lib/utils";

interface EventLocationProps {
    displayName: string;
    className?: string;
}

const EventLocation = ({ displayName, className }: EventLocationProps) => (
    <div className="flex items-center gap-2">
        <img
            alt="Location"
            className="text-icon-active h-4 w-4"
            src={MarkerPin}
        />
        <p className={cn(className)}>{displayName}</p>
    </div>
);

export default EventLocation;
